module.exports = __webpack_public_path__ + "static/media/trivia.466d153e.png";